import React from 'react';
import { COMPANY_OFFICE_ADDRESS_LINES, SUPPORT_EMAIL } from '../constants/companyInfo';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import './Page.css';

const Privacy = () => {
  return (
    <div className="page">
      <SeoHead {...PAGE_SEO.privacy} />
      <section className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="page-subtitle">Last updated: August 2026</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="legal-content">
            <div className="content-section">
              <h2>Introduction</h2>
              <p>
                At Unaffected Healthcare, we are committed to protecting your privacy. This Privacy
                Policy explains how we collect, use, disclose, and safeguard your information when
                you visit our website or use our employee healthcare benefit services.
              </p>
            </div>

            <div className="content-section">
              <h2>Information We Collect</h2>
              <p>We may collect information about you in a variety of ways:</p>
              <ul>
                <li>
                  <strong>Personal Information:</strong> Name, email address, phone number, and other
                  contact information
                </li>
                <li>
                  <strong>Usage Data:</strong> Information about how you interact with our website
                </li>
                <li>
                  <strong>Technical Data:</strong> IP address, browser type, device information
                </li>
              </ul>
            </div>

            <div className="content-section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Respond to your inquiries and requests</li>
                <li>Send you updates and communications</li>
                <li>Analyze usage patterns and trends</li>
                <li>Ensure security and prevent fraud</li>
              </ul>
            </div>

            <div className="content-section">
              <h2>Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your
                personal information against unauthorized access, alteration, disclosure, or
                destruction.
              </p>
            </div>

            <div className="content-section">
              <h2>Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Data portability</li>
              </ul>
            </div>

            <div className="content-section">
              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                {SUPPORT_EMAIL}
              </p>
              <p>
                Registered office: {COMPANY_OFFICE_ADDRESS_LINES.join(', ')}.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
